import { render, staticRenderFns } from "./RoleUpsert.vue?vue&type=template&id=5c97b613"
import script from "./RoleUpsert.vue?vue&type=script&lang=js"
export * from "./RoleUpsert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports